import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { MyParams, useSession } from 'App';
import {
  notApproveCommentText,
  useAnomalies,
  useComments,
  useStatuses,
  useTargetRegions,
} from '@shared';

export default function useEnhancedAudit() {
  const { audit: auditUuid } = useParams<keyof MyParams>() as MyParams;

  const { currentUser } = useSession();
  const { isLeadAuditor, isInstructor } = currentUser.roles;
  const { data: anomalies, refetch: refetchAnomalies } = useAnomalies(auditUuid);

  const { data: targetRegions = [], isSuccess: isSuccessTargetRegions } =
    useTargetRegions(auditUuid);

  // const { data: suspectRegions } = useQuery(['suspect regions', session], () =>
  //   auditApi2.getSuspectRegions(session)
  // )

  const { statuses, updateStatuses, isStatusesLoading } = useStatuses(auditUuid);
  const [comments, addComment, isCommentsLoading] = useComments(auditUuid);

  const [isPlaying, setIsPlaying] = useState(false);
  const [playedSeconds, setPlayedSeconds] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(4.0);
  const [progressPlayed, setProgressPlayed] = useState(0);
  const playerRef = useRef<ReactPlayer>(null);

  const [isOpenReviewIdentity, setIsOpenReviewIdentity] = useState(false);
  const [isOpenFinishAudit, setIsOpenFinishAudit] = useState(false);
  const [isExamAuditorApproved, setIsExamAuditorApproved] = useState(false);
  const [isNotificationShowing, setNotificationShowing] = useState(true);

  const handleSeekChange = (seek: number, isPlay = true) => {
    setIsPlaying(isPlay);
    playerRef.current?.seekTo(seek);
  };

  const handleNotApproveExamTaker = () => {
    setIsExamAuditorApproved(false);
    addComment(notApproveCommentText);
  };

  return {
    isLeadAuditor,
    isInstructor,
    isStatusesLoading,
    isCommentsLoading,
    isOpenReviewIdentity,
    isOpenFinishAudit,
    isExamAuditorApproved,
    isNotificationShowing,
    isPlaying,
    isSuccessTargetRegions,

    playedSeconds,
    playbackRate,
    progressPlayed,
    playerRef,

    auditUuid,
    anomalies,
    targetRegions,
    statuses,
    comments,

    handleNotApproveExamTaker,
    handleSeekChange,
    setIsOpenReviewIdentity,
    setIsOpenFinishAudit,
    setNotificationShowing,
    setIsExamAuditorApproved,
    setIsPlaying,
    setProgressPlayed,
    setPlaybackRate,
    setPlayedSeconds,
    updateStatuses,
    refetchAnomalies,
    addComment,
  };
}
